import api from './api.service';

export interface Terms {
  id: string;
  version: string;
  title: string;
  content: string;
  status: 'ACTIVE' | 'INACTIVE' | 'ARCHIVED';
  effectiveDate: string;
  createdAt: string;
  updatedAt: string;
}

export interface TermsAcceptance {
  id: string;
  termsId: string;
  customerId: string;
  ipAddress: string;
  userAgent: string;
  acceptedAt: string;
  additionalData: Record<string, any>;
  terms: Terms;
}

export interface CheckAcceptanceResponse {
  hasAccepted: boolean;
  terms?: Terms; // Opcional: só vem quando hasAccepted = false
}

export const termsService = {
  // Obter termos ativos
  getActiveTerms: async (): Promise<Terms> => {
    return api.get('/terms/active').then((res) => res.data);
  },

  // Verificar se customer aceitou
  checkCustomerAcceptance: async (): Promise<CheckAcceptanceResponse> => {
    return api.get('/terms/check/customer').then((res) => res.data);
  },

  // Aceitar termos como customer
  acceptTermsCustomer: async (termsId: string): Promise<any> => {
    return api.post('/terms/accept/customer', { termsId }).then((res) => res.data);
  },

  // Aceitar termos publicamente (durante cadastro)
  acceptTermsPublic: async (termsId: string, email: string): Promise<any> => {
    return api.post('/terms/accept/public', { termsId, email }).then((res) => res.data);
  },

  // Histórico de aceitações
  getCustomerAcceptances: async (): Promise<TermsAcceptance[]> => {
    return api.get('/terms/history/customer').then((res) => res.data);
  },
};
